import React from 'react';
import { FormattedMessage } from 'react-intl';
import './Footer.scss';
import velozLogoWhite from '../../../assets/images/EFAVeloz-Horizontal-White-1536x326.png';
import FooterForm from '../../FooterForm/FooterForm';

const Footer = ({ language, changeLanguage }) => {
  const socialIcons = (
    <>
      <div className="socials inline-inside">
        <a
          className="socials-item"
          href="https://www.facebook.com/ElectricForAll/"
          target="_blank"
          rel="noopener noreferrer"
          title="Facebook"
        >
          <i className="socials-item-icon facebook "></i>
        </a>
        <a
          className="socials-item"
          href="https://www.instagram.com/electricforall/"
          target="_blank"
          rel="noopener noreferrer"
          title="Instagram"
        >
          <i className="socials-item-icon instagram "></i>
        </a>
        <a
          className="socials-item"
          href="https://www.youtube.com/@electricforall"
          target="_blank"
          rel="noopener noreferrer"
          title="YouTube"
        >
          <i className="socials-item-icon youtube "></i>
        </a>
        <a
          className="socials-item"
          href="https://www.tiktok.com/@electricforall"
          target="_blank"
          rel="noopener noreferrer"
          title="TikTok"
        >
          <i className="socials-item-icon tiktok "></i>
        </a>
      </div>
    </>
  );

  return (
    <div className="Footer">
      <div className="veloz-footer-row">
        <div className="container">
          <div className="veloz-content">
            <div className="veloz-logo">
              <img src={velozLogoWhite} alt="Veloz Logo" />
            </div>
            <p>
              <FormattedMessage
                id="footer.velozMission.footer"
                defaultMessage="Veloz's mission, as a nonprofit organization, is to educate the public regarding the state of electric vehicle technology and its importance to a clean and healthy environment in a non-commercial manner."
                description="Footer Veloz Mission"
              />
            </p>
            <a
              className="footer-donate-button"
              href="https://www.veloz.org/donate/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Donate
            </a>
          </div>
          <div className="veloz-form-container">
            <h3>
              <FormattedMessage
                id="footer.formTitle"
                defaultMessage="Join the Electric Vehicle Revolution"
                description="Join the Electric Vehicle Revolution"
              />
            </h3>
            <p>
              <FormattedMessage
                id="footer.formSubTitle"
                defaultMessage="Get updates about electric vehicles, incentives and rebates."
                description="Get updates about electric vehicles, incentives and rebates."
              />
            </p>
            <div className="veloz-form">
              <FooterForm />
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="copyright-notice row">
          <div className="col-md-3">
            <p
              style={{
                textAlign: 'left',
                marginLeft: -10,
                color: '#fff',
              }}
            >
              <span style={{ fontFamily: 'Arial, Helvetica' }}>&copy;</span>
              {new Date().getFullYear().toString()} Veloz |{' '}
              <FormattedMessage
                id="footer.allRights"
                defaultMessage="All Rights Reserved"
                description="All Rights Reserved"
              />
            </p>
          </div>

          <div className="col-md-6 footer-links">
            <p
              style={{ marginBottom: 0, color: '#fff' }}
              className="d-flex align-items-center justify-content-center"
            >
              <a
                className="me-2"
                title="Veloz"
                href="https://www.veloz.org/contact/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="footer.contact"
                  defaultMessage="Contact"
                  description="Contact"
                />
              </a>
              <span className="me-2">|</span>
              <a
                className="me-2 ms-2"
                href="https://www.electricforall.org/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="footer.privacyPolicy"
                  defaultMessage="Privacy Policy"
                  description="Privacy Policy"
                />
              </a>
              <span className="me-2">|</span>
              <a
                className="me-2 ms-2"
                href="https://www.electricforall.org/privacy-preferences/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="footer.privacyPreferences"
                  defaultMessage="Privacy Preferences"
                  description="Privacy Preferences"
                />
              </a>
              <span className="me-2">|</span>
              <a
                className="me-2 ms-2"
                href="https://www.electricforall.org/terms-of-service/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="footer.termsAndConditions"
                  defaultMessage="Terms of Service"
                  description="Terms of Service"
                />
              </a>
              <span className="me-2">|</span>
              <a
                className="me-2 ms-2"
                href="https://www.electricforall.org/accessibility-statement/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="footer.accessibilityStatement"
                  defaultMessage="Accessibility Statement"
                  description="Accessibility Statement"
                />
              </a>
              <span className="me-2">|</span>
              <a
                className="ms-2"
                href="https://www.electricforall.org/sitemap/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="footer.sitemap"
                  defaultMessage="Sitemap"
                  description="Sitemap"
                />
              </a>
            </p>
          </div>
          <div className="col-md-3 social-links">
            <div
              style={{
                marginBottom: 0,
                color: '#fff',
                textAlign: 'right',
              }}
            >
              {socialIcons}
            </div>
          </div>
          <div className="veloz-disclaimer">
            <p>
              Veloz does not support or promote any particular car manufacturer
              and nothing on this website is intended as an endorsement.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
